<script setup>
import "@/styles/css/calculator.scss";
import { onMounted } from "vue";
onMounted(() => {
  jQuery(document).ready(function () {
    jQuery(".butt-nav").click(function () {
      jQuery(".caclulator-nav-container-inner ul li.active").removeClass(
        "active"
      );
      jQuery(this).addClass("active");
    });
  });

  $(".section-link").on("click", function (e) {
    e.preventDefault();

    var self = $(this);
    var target = self.data("target");
    var subject = $('[data-section-name="' + target + '"]');
    var offset = subject.offset().top - 100;

    $("html, body").animate(
      {
        scrollTop: offset,
      },
      100
    );
  });
});
</script>
<template>
  <div class="page-container">
    <!--banner-->
    <section class="calculator-banner banner-inner">
      <div class="heading">
        <h1 class="wow fadeInDown" data-wow-duration="1s">
          Tools &amp; Calculators
        </h1>
        <p class="wow fadeInUp" data-wow-duration="1s">
          Explore our tools to help you make better trading decisions
        </p>
      </div>
    </section>
    <!--/banner-->

    <!--Nav-->
    <section class="calculators calculators-nav-sec">
      <div class="nav-tab-container">
        <div class="caclulator-nav-container-inner">
          <ul>
            <li class="butt-nav active">
              <a
                class="section-link"
                data-target="1"
                href="/calculator/#calculator-1"
                >Brokerage Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="2"
                href="/calculator/#calculator-2"
                >Margin Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="3"
                href="/calculator/#calculator-3"
                >MF Returns Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="4"
                href="/calculator/#calculator-4"
                >SIP Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="5"
                href="/calculator/#calculator-5"
                >NPV Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="6"
                href="/calculator/#calculator-6"
                >FV Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="7"
                href="/calculator/#calculator-7"
                >SWP Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="8"
                href="/calculator/#calculator-8"
                >ELSS Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="9"
                href="/calculator/#calculator-9"
                >Option Value Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="10"
                href="/calculator/#calculator-10"
                >NPS Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="11"
                href="/calculator/#calculator-11"
                >PPF Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="12"
                href="/calculator/#calculator-12"
                >CAGR Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="13"
                href="/calculator/#calculator-13"
                >NSC Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="14"
                href="/calculator/#calculator-14"
                >SSY Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="15"
                href="/calculator/#calculator-15"
                >Compound Interest Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="16"
                href="/calculator/#calculator-16"
                >Atal Pension Yojana Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="17"
                href="/calculator/#calculator-17"
                >Gratuity calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="18"
                href="/calculator/#calculator-18"
                >Simple Interest Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="19"
                href="/calculator/#calculator-19"
                >Fixed Deposit Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="20"
                href="/calculator/#calculator-20"
                >GST Calculator</a
              >
            </li>
            <li class="butt-nav">
              <a
                class="section-link"
                data-target="21"
                href="/calculator/#calculator-21"
                >HRA Calculator</a
              >
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!--/Nav-->

    <!--tools description-->
    <section class="calculators calculators-sec">
      <div class="caclulator-container-inner">
        <div class="left" id="calculator-1" data-section-name="1">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>Brokerage Calculator</h3>
                <p>
                  Our brokerage calculator is extremely helpful to find out what
                  your break-even point on any trade should be and how much you
                  can ear on your trades.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/brokerage-calculator/"
                    class="button button--aylen !bg-transparent"
                    >See how much you save</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/BrokerageCalculator_Artwork-1-min.png"
                  alt="Brokerage Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-2" data-section-name="2">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Margin Calculator
                  <span> New </span>
                </h3>
                <p>
                  The margin calculator can be used to figure out exactly how
                  much money you need to maintain a portfolio of Equities,
                  Futures, Options, Currency Derivatives and Commodities.<br />
                  <a
                    href="https://www.dropbox.com/sh/5swgzb09l8t501r/AAD9VKUxJ4S5Z296UiD_qrH_a?dl=0"
                    target="_blank"
                    rel="noopener"
                  >
                    View Margin files</a
                  >
                </p>
                <!-- <div class="calculator-button">
                  <a
                    href="/calculator/span-calculator/"
                    class="button button--aylen !bg-transparent"
                    >Calculate your margin</a
                  >
                </div> -->
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/MarginCalculator_Artwork-min.png"
                  alt="Margin Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-3" data-section-name="3">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Mutual Fund Returns Calculator
                  <span> New </span>
                </h3>
                <p>
                  This calculator can be used to find out how much your total
                  investment in a mutual fund will be worth at the end of a
                  specified period, for a given rate of return. You can also use
                  this calculator to determine how much you should invest to
                  reach a target amount at the end of a specified period.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/mutual-fund-return/"
                    class="button button--aylen !bg-transparent"
                    >Calculate MF Returns</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/MutualFundReturnsCalculator_Artwork-min.png"
                  alt="Mutual Fund Returns Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-4" data-section-name="4">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  SIP Calculator
                  <span> New </span>
                </h3>
                <p>
                  Our SIP calculator helps you to estimate your returns for a
                  specific SIP amount at a given interest rate at the end of a
                  specified period. You can also use this calculator to
                  determine how much you should invest every month to reach a
                  target amount at the end of a specified period.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/sip-calculator/"
                    class="button button--aylen !bg-transparent"
                    >Calculate SIP Returns</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/SIPCalculator_Artwork-min.png"
                  alt="SIP Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-5" data-section-name="5">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  NPV Calculator
                  <span> New </span>
                </h3>
                <p>
                  NPV or the net present value is an important tool that shows
                  the difference between the present value of future cash flows
                  and the current investment. We derive the present value of
                  expected cash flows by discounting them at a specified rate of
                  return. NPV is a widely used cash-budgeting method for
                  assessing projects and investments.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/npv/"
                    class="button button--aylen !bg-transparent"
                    >Calculate NPV Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/NPVCalculator_Artwork-min.png"
                  alt="NPV Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-6" data-section-name="6">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Future Value Calculator
                  <span> New </span>
                </h3>
                <p>
                  A key factor that guides one’s investments is the future value
                  of the investment. But a key challenge most people face is
                  this: How to evaluate the future value of one’s investments?
                  This is an important question as it provides some clarity
                  about one’s financial situation in the future, which in turn
                  can help one to make more informed decisions.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/future-value/"
                    class="button button--aylen !bg-transparent"
                    >Calculate FV Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/FutureValueCalculator_Artwork-min.png"
                  alt="Future Value Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-7" data-section-name="7">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  SWP Calculator
                  <span> New </span>
                </h3>
                <p>
                  A systematic withdrawal plan (SWP) provides regular income to
                  investors. You can withdraw a fixed or a variable amount on a
                  predetermined date every month, quarter, or year. Cash flows
                  can be customised to withdraw either a fixed amount or the
                  investment’s capital gains.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/swp/"
                    class="button button--aylen !bg-transparent"
                    >Calculate SWP Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/SWPCalculator_Artwork-min.png"
                  alt="SWP Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-8" data-section-name="8">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  ELSS Calculator
                  <span> New </span>
                </h3>
                <p>
                  An equity-linked savings scheme (ELSS) is an open-ended equity
                  mutual fund offering tax benefits up to ₹1,50,000, under
                  Section 80C of the Income Tax Act, 1961. By investing in ELSS,
                  you can save some amount every year in taxes and promote the
                  habit of long-term investment and saving.In addition to equity
                  and debt securities, ELSS funds also invest in fixed-income
                  securities. Thus, investors can gain exposure to a diversified
                  portfolio by investing in ELSS.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/elss/"
                    class="button button--aylen !bg-transparent"
                    >Calculate ELSS Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/ELSSCalculator_Artwork-min.png"
                  alt="ELSS Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-9" data-section-name="9">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Option Value Calculator
                  <span> New </span>
                </h3>
                <p>
                  <span style="font-weight: 400"
                    >The option value is the value of retaining options for the
                    future. For this choice to be available, you are ready to
                    pay a premium. Options, whether real life or financial,
                    always involves pay-offs or trade-offs. Usually, each of
                    these choices creates a set of pay-offs linked to further
                    choices down the line.</span
                  >
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/option-value/"
                    class="button button--aylen !bg-transparent"
                    >Calculate Option Value Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/OptionValueCalculator_Artwork-min.png"
                  alt="Option Value Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-10" data-section-name="10">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  NPS Calculator
                  <span> New </span>
                </h3>
                <p>
                  National Pension Scheme (NPS) Calculator helps you to know the
                  monthly pension and lump sum amount that you may get at the
                  time of retirement. NPS Calculator enables you to decide your
                  monthly contribution towards NPS accordingly. Investment in
                  NPS offers tax benefit under Section 80CCD and can be
                  considered as an attractive retirement solution. NPS
                  calculator is a handy tool to make an informed investment in
                  NPS.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/nps/"
                    class="button button--aylen !bg-transparent"
                    >Calculate NPS Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/NPSCalculator_Artwork-min.png"
                  alt="NPS Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-11" data-section-name="11">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  PPF Calculator
                  <span> New </span>
                </h3>
                <p>
                  If you are planning to invest in PPF and unsure about how much
                  to invest or how much returns you may get on investing a
                  certain amount, our PPF calculator is here for you. After you
                  decide the amount you can afford to invest on a regular basis,
                  the calculator considers the tenure to be 15 years and the
                  prevalent interest rate to calculate the returns.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/ppf-public-provident-fund/"
                    class="button button--aylen !bg-transparent"
                    >Calculate PPF Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/03/PPF_Artwork.png"
                  alt="PPF Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-12" data-section-name="12">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Compound Annual Growth Rate Calculator
                  <span> New </span>
                </h3>
                <p>
                  <span style="font-weight: 400"
                    >CAGR indicates the compounded returns you earn on an annual
                    basis irrespective of the annual performance of your
                    investment. CAGR lets you know how much your investment grew
                    over a period of several years.</span
                  >
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/cagr-calculate-compound-annual-growth-rate/"
                    class="button button--aylen !bg-transparent"
                    >Calculate CAGR Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/03/CAGR_Artwork.png"
                  alt="Compound Annual Growth Rate Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-13" data-section-name="13">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  National Savings Certificate Calculator
                  <span> New </span>
                </h3>
                <p>
                  <span style="font-weight: 400"
                    >One of the most popular savings investment avenues for
                    conservative investors is the National Savings Certificate
                    (NSC). Issued by India Post, an NSC has a tenure of five
                    years and pays a fixed rate of interest compounded annually.
                    But many want to know how much money they would get from
                    investing in an NSC. For these investors, it makes sense to
                    use the NSC calculator and understand the nuances involved
                    in investing in an NSC.</span
                  >
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/nsc-national-savings-certificate/"
                    class="button button--aylen !bg-transparent"
                    >Calculate NSC Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/03/NSC_Artwork.png"
                  alt="National Savings Certificate Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-14" data-section-name="14">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Sukanya Samriddhi Yojana Calculator
                  <span> New </span>
                </h3>
                <p>
                  <span style="font-weight: 400">SSY is </span
                  ><span style="font-weight: 400"
                    >a government-backed small savings scheme for the benefit of
                    a girl child. </span
                  ><span style="font-weight: 400"
                    >It is a high-yielding, tax-saving investment instrument
                    whose core objective is to secure the future of the girl
                    child.</span
                  >
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/sukanya-samriddhi-yojana/"
                    class="button button--aylen !bg-transparent"
                    >Calculate SSY Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/03/SSY_Artwork.png"
                  alt="Sukanya Samriddhi Yojana Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-15" data-section-name="15">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Compound Interest Calculator
                  <span> New </span>
                </h3>
                <p>
                  <span style="font-weight: 400"
                    >A Compound Interest calculator is used to calculate the
                    projection for compound growth for your savings account or
                    investment for different periods of time, based upon a
                    certain rate of interest.
                  </span>
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/compound-interest/"
                    class="button button--aylen !bg-transparent"
                    >Calculate CI Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/CompoundInterestCalculator_Artwork.png"
                  alt="Compound Interest Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-16" data-section-name="16">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Atal Pension Yojana Calculator
                  <span> New </span>
                </h3>
                <p>
                  The APY (Atal Pension Yojana) calculator will help you
                  calculate the real returns you can expect if you are investing
                  in the APY scheme. It is an instant result based calculator
                  that assesses how much interest can be earned on the basis of
                  pension expectation after retirement and your age.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/atal-pension-yojana-apy/"
                    class="button button--aylen !bg-transparent"
                    >APY Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/APYCalculator_Artwork-1.png"
                  alt="Atal Pension Yojana  Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-17" data-section-name="17">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Gratuity calculator
                  <span> New </span>
                </h3>
                <p>
                  A Gratuity calculator is a tool to get an instant estimate of
                  the amount you are eligible to receive as an employee on
                  leaving a job after rendering at least 5 years of service to
                  the company. The inputs that are required to use this
                  calculator are your last drawn salary, number of years served
                  to the company (including months) and your Dearness Allowance
                  component of your salary.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/gratuity/"
                    class="button button--aylen !bg-transparent"
                    >Gratuity Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/GratuityCalculator_Artwork-1.png"
                  alt="Gratuity calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-18" data-section-name="18">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Simple Interest Calculator
                  <span> New </span>
                </h3>
                <p>
                  Use our Simple Interest calculator to calculate the interest
                  you can earn on investments or savings without compounding.
                  You may calculate the simple interest on the principal amount
                  on annually.&nbsp; The inputs that are required to use this
                  calculator are principal amount, number of years and interest
                  rate.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/simple-interest/"
                    class="button button--aylen !bg-transparent"
                    >Simple Interest Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/SimpleCalculator_Artwork-1.png"
                  alt="Simple Interest Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-19" data-section-name="19">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  Fixed Deposit Calculator
                  <span> New </span>
                </h3>
                <p>
                  In India, fixed deposits are one of the most popular
                  investment options. It provides stable or guaranteed returns.
                  Also, you can pick a duration that works for you.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/fd-fixed-deposit/"
                    class="button button--aylen !bg-transparent"
                    >Fixed Deposit Return</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/04/FDCalculator_Artwork-1.png"
                  alt="Fixed Deposit Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="right" id="calculator-20" data-section-name="20">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  GST Calculator
                  <span> New </span>
                </h3>
                <p>
                  An online calculator, the GST calculator is used to compute
                  the GST payable to the Government of India either monthly or
                  quarterly. It is very easy to use, and is dynamic as it can be
                  used to calculate for all types of users like retailers,
                  wholesalers, buyers and manufacturers
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/gst/"
                    class="button button--aylen !bg-transparent"
                    >GST Calculator</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/05/GSTCalculator.png"
                  alt="GST Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
        <div class="left" id="calculator-21" data-section-name="21">
          <div class="container">
            <div class="item-wrapper">
              <div class="calculator-desc">
                <h3>
                  HRA Calculator
                  <span> New </span>
                </h3>
                <p>
                  House Rent Allowance (HRA) is that part of the salary that is
                  provided by the employer for the expense towards accommodation
                  rentals.
                </p>
                <div class="calculator-button">
                  <a
                    href="/calculator/hra-house-rent-allowance-calculator/"
                    class="button button--aylen !bg-transparent"
                    >HRA Calculator</a
                  >
                </div>
              </div>
              <!-- end of calculator-desc -->
              <div class="calculator-img">
                <img
                  src="https://upstox.com/app/uploads/2022/05/HRACalculator_Artwork.png"
                  alt="HRA Calculator - Upstox"
                />
              </div>

              <!-- end of calculator-img -->
            </div>
            <!-- end of item-wrapper -->
          </div>
          <!-- end of container -->
        </div>
        <!-- end of image position class -->
      </div>
      <!-- end of caclulator-container-inner -->
    </section>
  </div>
</template>
<style scoped>
</style>
